import { CumulativeReportFilterValues } from 'pages/Finance/CumulativeReport/CumulativeReportFilter';
import { ExpandIconButton } from 'shared/mui/IconButtons';
import { Typography } from 'shared/mui/Typography';
import { formatRangeInputInTz } from 'utils/date';

import { StyledCumulativeReportSummaryPeriod } from './CumulativeReportSummary.styled';

type CumulativeReportSummaryPeriodProps = {
  filters: CumulativeReportFilterValues;
  toggleIsOpen: () => void;
  isOpen: boolean;
};

export const CumulativeReportSummaryPeriod: React.FC<CumulativeReportSummaryPeriodProps> = ({
  filters,
  toggleIsOpen,
  isOpen,
}) => {
  const alertText = `Итого по счетам за период ${formatRangeInputInTz(
    [filters?.periodFrom, filters?.periodTo],
    {
      timezone: filters?.timezone,
      format: 'dd.MM.yyyy',
    },
  )}`;

  return (
    <StyledCumulativeReportSummaryPeriod isOpen={isOpen}>
      <Typography variant="h6">{alertText}</Typography>
      <ExpandIconButton isExpanded={isOpen} onClick={toggleIsOpen} />
    </StyledCumulativeReportSummaryPeriod>
  );
};
